var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var InformationIcon = function (props) {
    return (_jsxs("svg", __assign({ width: "50", height: "50", viewBox: "0 0 50 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("rect", { width: "50", height: "50", rx: "25", fill: "url(#paint0_linear_9374_25918)" }), _jsx("path", { d: "M33 15C35 15 35 17 35 17V20H31M33 15C31 15 31 17 31 17V20M33 15H20C18 15 18 17 18 17V30M31 20V33C31 33 31 35 29 35M29 35C27 35 27 33 27 33V30H15V33C15 33 15 35 17 35H29ZM22 21H27M22 25H27", stroke: "#FCFCFC", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }), _jsx("defs", { children: _jsxs("linearGradient", { id: "paint0_linear_9374_25918", x1: "-1.67638e-08", y1: "15.25", x2: "51.1509", y2: "19.7936", gradientUnits: "userSpaceOnUse", children: [_jsx("stop", { "stop-color": "#C566FF" }), _jsx("stop", { offset: "1", "stop-color": "#5C00B9" })] }) })] })));
};
export default InformationIcon;
